"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAppLocaleData = exports.getDefaultCountryForTranslatedLabels = exports.getDefaultLocale = undefined;

var _de = require("react-intl/locale-data/de");

var _de2 = _interopRequireDefault(_de);

var _en = require("react-intl/locale-data/en");

var _en2 = _interopRequireDefault(_en);

var _fr = require("react-intl/locale-data/fr");

var _fr2 = _interopRequireDefault(_fr);

var _zh = require("react-intl/locale-data/zh");

var _zh2 = _interopRequireDefault(_zh);

var _nl = require("react-intl/locale-data/nl");

var _nl2 = _interopRequireDefault(_nl);

var _ja = require("react-intl/locale-data/ja");

var _ja2 = _interopRequireDefault(_ja);

var _it = require("react-intl/locale-data/it");

var _it2 = _interopRequireDefault(_it);

var _es = require("react-intl/locale-data/es");

var _es2 = _interopRequireDefault(_es);

var _pt = require("react-intl/locale-data/pt");

var _pt2 = _interopRequireDefault(_pt);

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getDefaultLocale = function getDefaultLocale(country, language) {
  return language + '-' + country.toUpperCase();
};

var getDefaultCountryForTranslatedLabels = function getDefaultCountryForTranslatedLabels(country, role) {
  var defaultCountry = country;
  if (role === "liq" && country.toUpperCase() === "HK") {
    defaultCountry = "gb";
  }
  return defaultCountry;
};

var addAppLocaleData = function addAppLocaleData() {
  (0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_de2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_zh2.default), _toConsumableArray(_nl2.default), _toConsumableArray(_ja2.default), _toConsumableArray(_es2.default), _toConsumableArray(_pt2.default), _toConsumableArray(_it2.default)));
};

exports.getDefaultLocale = getDefaultLocale;
exports.getDefaultCountryForTranslatedLabels = getDefaultCountryForTranslatedLabels;
exports.addAppLocaleData = addAppLocaleData;